import { BrowserRouter, Routes, Route } from 'react-router';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { BookingsPage } from './pages/BookingsPage';
import { SettingsPage } from './pages/SettingsPage';
import { StaffPage } from './pages/StaffPage';
import { OwnersPage } from './pages/OwnersPage';
import { LogsPage } from './pages/LogsPage';
import { BillingPage } from './pages/BillingPage';
import { AdminAIPage } from './pages/AdminAIPage';

export function App(): React.JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="bookings" element={<BookingsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="staff" element={<StaffPage />} />
          
          {/* Админские маршруты */}
          <Route path="owners" element={<OwnersPage />} />
          <Route path="ai-agents" element={<AdminAIPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="billing" element={<BillingPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
